module.exports = __webpack_public_path__ + "images/Material-design.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/Material-design.jpg
 ** module id = 47
 ** module chunks = 1
 **/